import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: "fullname"
})
export class FullnamePipe implements PipeTransform {

  transform(value: any, index: number): string {
    if (value) {
      const fullname = value.split(",");
      return fullname[index];
    } else {
      return "N/A";
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/fullname.pipe.ts